export default __webpack_public_path__ + "static/media/tamballapalli-ramadevu.ca5b8724.png";